import * as React from 'react'

export type DeviceClass = 'phone' | 'tablet' | 'desktop'

// Mirrors the Tailwind screens in tailwind.config.cjs (tablet: 834px,
// desktop: 1200px). A phone turned landscape (e.g. 844×390) is still a phone:
// the tablet layout needs the height for its side panel and docked form.
const PHONE_QUERY =
  '(max-width: 833px), (max-height: 500px) and (max-width: 1199px)'
const TABLET_QUERY = '(min-width: 834px) and (max-width: 1199px)'

function read(): DeviceClass {
  // jsdom (tests) and very old browsers have no matchMedia — the desktop
  // layout is the one every existing test was written against.
  if (typeof window === 'undefined' || !window.matchMedia) return 'desktop'
  if (window.matchMedia(PHONE_QUERY).matches) return 'phone'
  if (window.matchMedia(TABLET_QUERY).matches) return 'tablet'
  return 'desktop'
}

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {}
  const lists = [PHONE_QUERY, TABLET_QUERY].map((q) => window.matchMedia(q))
  lists.forEach((l) => l.addEventListener('change', onChange))
  return () => lists.forEach((l) => l.removeEventListener('change', onChange))
}

/**
 * Which shell to render. Phone and tablet get the mobile shell (src/mobile);
 * desktop keeps LayoutHome exactly as it was.
 */
export default function useDeviceClass(): DeviceClass {
  return React.useSyncExternalStore(subscribe, read, () => 'desktop')
}
